import ProtectedRoute from "@components/ProtectedRoute";
import CollectCampaigns from "@pages/Contents/Corporate/CollectCampaigns";
import AddCollectCampaign from "@pages/Contents/Corporate/CollectCampaigns/Add";
import { CollectCampaignStateProvider } from "@pages/Contents/Corporate/CollectCampaigns/context/CollectCampaignContext";
import { NotificationStateProvider } from "@pages/Contents/Corporate/Notifications/context/NotificationContext";
import EditCampaign from "@pages/Contents/Corporate/CollectCampaigns/Edit";
import Monitoring from "@pages/Contents/Corporate/CollectCampaigns/Monitoring";
import { PagesID } from "@utils/utilsConfigurations";
import { useIsInclude } from "../../../RoutersCst";
import MonitoringUser from "@pages/Contents/Corporate/CollectCampaigns/Monitoring/User";
import MonitoringExternalTraining from "@pages/Contents/Corporate/CollectCampaigns/Monitoring/ExternalTraining";

const useCorporateCollectCampaigns = () => {
  const { isInclude } = useIsInclude();
  const basePermissions = "corporate";

  return {
    path: "collect-campaigns",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute isAllowed={isInclude(basePermissions)}>
            <CollectCampaigns page={PagesID["corporate.collect-campaign"]} />
          </ProtectedRoute>
        ),
      },
      {
        path: "add",
        element: (
          <ProtectedRoute isAllowed={isInclude(`${basePermissions}`)}>
            <CollectCampaignStateProvider>
              <AddCollectCampaign
                page={PagesID["corporate.collect-campaign.add"]}
              />
            </CollectCampaignStateProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: "edit/:idCampaign",
        element: (
          <ProtectedRoute isAllowed={isInclude(`${basePermissions}`)}>
            <CollectCampaignStateProvider>
              <EditCampaign />
            </CollectCampaignStateProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: "monitor-campaign/:idCampaign",
        element: (
          <ProtectedRoute isAllowed={isInclude(`${basePermissions}`)}>
            <Monitoring page={PagesID["corporate.collect-campaign.monitor"]} />
          </ProtectedRoute>
        ),
      },
      {
        path: "monitor-campaign/:idCampaign/campaign-user/:idUser",
        element: (
          <ProtectedRoute isAllowed={isInclude(`${basePermissions}`)}>
            <MonitoringUser
              page={PagesID["corporate.collect-campaign.monitor.user"]}
            />
          </ProtectedRoute>
        ),
      },
      {
        path: "monitor-campaign/:idCampaign/campaign-user/:idUser/external-training",
        element: (
          <ProtectedRoute isAllowed={isInclude(`${basePermissions}`)}>
            <MonitoringExternalTraining
              page={
                PagesID[
                  "corporate.collect-campaign.monitor.user.external-training"
                ]
              }
            />
          </ProtectedRoute>
        ),
      },
    ],
  };
};

export default useCorporateCollectCampaigns;
